import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import { ToastProvider } from "./components";
import "./App.css";

const Landing = lazy(() => import("./pages/landing"));
const Login = lazy(() => import("./pages/login"));
const CreateAccount = lazy(() => import("./pages/create-account"));
const ForgotPassword = lazy(() => import("./pages/forgot-password"));
const VerifyEmail = lazy(() => import("./pages/verify-email"));
const AuthCallback = lazy(() => import("./pages/auth-callback"));
const Terms = lazy(() => import("./pages/terms"));
const Privacy = lazy(() => import("./pages/privacy"));
const Dashboard = lazy(() => import("./pages/dashboard"));

function App() {
  return (
    <ToastProvider>
      <Router>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/create-account" element={<CreateAccount />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </ToastProvider>
  );
}

export default App;
